export const generateFileDownload = (content: string, filename: string) => {
  const blob = new Blob([content], { type: 'text/csv;charset=utf-8;' });

  // Create a download link and trigger the download
  const link = document.createElement('a');
  if (link.download !== undefined) {
    const url = URL.createObjectURL(blob);
    link.setAttribute('href', url);
    link.setAttribute('download', filename);
    link.style.visibility = 'hidden';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
};

/**
 * Converts an HTMLCanvasElement to a base64-encoded image string.
 *
 * @param htmlCanvas - The HTMLCanvasElement to convert. If undefined, the function returns undefined.
 * @param options - Configuration options for the image conversion.
 * @param options.imageType - The MIME type of the image. Defaults to 'image/jpeg'.
 * @param options.quality - The quality of the image (for image types that support quality settings).
 *                           Should be a number between 0.0 (worst) and 1.0 (best). Defaults to 0.6.
 * @returns A base64-encoded string representation of the image, or undefined if the canvas or context is invalid.
 */
export const canvasToImage = (
  htmlCanvas: HTMLCanvasElement | undefined,
  options?: {
    imageType?: string;
    quality?: number;
    fillStyle?: string;
  }
): string | undefined => {
  if (htmlCanvas === undefined) {
    return;
  }

  const quality = options?.quality ?? 0.6;
  const imageType = options?.imageType ?? 'image/jpeg';

  const canvas2 = document.createElement('canvas');
  canvas2.width = htmlCanvas.width;
  canvas2.height = htmlCanvas.height;

  const context2 = canvas2.getContext('2d');
  if (!context2) {
    return;
  }

  // fill background
  if (options?.fillStyle) {
    context2.fillStyle = options.fillStyle;
  }
  context2.fillRect(0, 0, canvas2.width, canvas2.height);
  context2.drawImage(htmlCanvas, 0, 0);
  const imgData = canvas2.toDataURL(imageType, quality); // quality between 0.0 (worst) and 1.0 (best)
  return imgData;
};

import React from 'react';

export function convertDivClickToButtonClick(
  e: React.MouseEvent<HTMLDivElement, MouseEvent>
): React.MouseEvent<HTMLButtonElement, MouseEvent> {
  // Reuse the native event but cast the target/currentTarget to HTMLButtonElement
  return {
    ...e,
    currentTarget: e.currentTarget as unknown as HTMLButtonElement,
    target: e.target as unknown as HTMLButtonElement,
  };
}
